import {Component, HostBinding, Input} from '@angular/core';
import {Blocks} from 'app/entities/blockElements/block.entity';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';

@Component({
  selector: 'app-block-elements',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementsComponent extends BlockElementAbstractComponent<Blocks[]> {
  @Input() public blockElements: Blocks[] | any[] = [];

  @HostBinding('class')
  get classes() {
    const classes = this.rootElement ? ['root-block-row'] : ['row'];

    const hasInlineElements = this.blockElements.find((item) => this.isContainer(item?.type) && item?.settings?.width === 'inline');

    if (hasInlineElements) {
      classes.push('block-inline-wrapper');
    }

    return classes;
  }

  // @todo remove to entity
  isContainer(type) {
    return ['basic', 'empty', 'card'].includes(type);
  }
}
